module.exports = __webpack_public_path__ + "static/media/Mock-Up-Application.3d0957d2.png";